import styles from './Card.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function Card({ children, background = "bg-white", outline = false, className, style, isButton = false, onClick, tabIndex, hidden, id, fullHeight = false }) {
  const classNameArray = className?.split(' ') || [];

	return isButton ? (
		<button id={id} className={cx(['ns_card', 'card', 'card-button', background, outline && 'isOutlined', ...classNameArray, fullHeight && 'full-height'])} style={style} onClick={onClick} tabIndex={tabIndex} hidden={hidden} >
			{children}
		</button>
	) : (
		<div id={id} className={cx(['ns_card', 'card', background, outline && 'isOutlined', ...classNameArray, fullHeight && 'full-height'])} style={style} hidden={hidden}>
			{children}
		</div>
	);
}
